import { Modal } from "shared/ui/components/Modal";

import { Button } from "shared/ui/components/Button";
import { Loader } from "shared/ui/components/Loader";
import { Typography } from "shared/ui/components/Typography";

import styles from "./InfoModal.module.scss";

const InfoModal = ({
  open,
  withLoader,
  title,
  text,
  caption,
  confirmText,
  onConfirmClick,
  onClose,
}: any) => (
  <Modal className={styles.modal} open={open} onClose={onClose}>
    <div className={styles.inner}>
      {withLoader && <Loader className={styles.loader} />}
      {title && (
        <Typography className={styles.title} variant="bodyL">
          {title}
        </Typography>
      )}
      {text && (
        <Typography withHTML className={styles.text} variant="h3">
          {text}
        </Typography>
      )}
      {caption && (
        <Typography className={styles.caption} variant="bodyL">
          {caption}
        </Typography>
      )}
      <Button
        className={styles.action}
        variant="black"
        onClick={onConfirmClick}
      >
        {confirmText}
      </Button>
    </div>
  </Modal>
);

export default InfoModal;
